import axios from "axios";
import { Pagination } from "components/Pagination";
import { Animate, Grid, Search, Table, ViewContext } from "components/lib";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./styles.module.scss";

export function VehiclesArchived(props) {
  const { id: company_id } = useParams();
  const [payload, setPayload] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQueryString, setSearchQueryString] = useState("");

  const context = useContext(ViewContext);

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  async function runAPI(page, search) {
    setLoading(true);

    await axios
      .get(
        `/api/vehicle?page=${page}&search=${search}&company_id=${company_id}&active=false&type=vehicle`
      )
      .then((res) => {
        setLoading(false);
        setPayload(res.data.data);

        var tempData = [];

        res.data.data.data.map((value, index) => {
          tempData.push({
            id: value.id,
            year: value.year,
            make: value.make,
            model: value.model,
            VIN: value.vin,
            "VIN Number": value.vin,
            type: value.type,
            class: value.class,
            bodytype: value.bodytype,
            stated_value: formatter.format(value.stated_value),
            status: value.active ? "Active" : "Inactive",
          });
        });

        setData(tempData);
      })
      .catch((err) => {
        setLoading(false);

        console.log(err);

        context.notification.show(
          "Failed to load table data",
          "error",
          true,
          "toast",
          "x-circle"
        );
      });
  }

  async function activeVehicle(id) {
    await axios
      .patch(`/api/vehicle/${id}`, { active: true, status: "active" })
      .then((res) => {
        setLoading(false);

        runAPI(page, searchQueryString);

        context.notification.show(
          "Vehicle actived!",
          "success",
          true,
          "toast",
          "check-circle"
        );
      })
      .catch((err) => {
        setLoading(false);

        context.notification.show(
          "Failed to arquive vehicle.",
          "error",
          true,
          "toast",
          "x-circle"
        );
      });
  }

  useEffect(() => {
    runAPI(page, searchQueryString);
  }, [searchQueryString]);

  useEffect(() => {
    runAPI(page, "");
  }, []);

  return (
    <Animate type="pop">
      <div
        style={{
          display: "flex",
          alignContent: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex" }}>
          <div
            onClick={() => {
              window.location.href = "/app/company/" + company_id + "/vehicles";
            }}
            style={{
              backgroundColor: "#EAEAEA",
              width: "150px",
              color: "#090E3480",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: "pointer",
            }}
          >
            Active
          </div>
          <div
            style={{
              width: "150px",
              backgroundColor: "black",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 10,
              fontSize: 16,
              fontWeight: 600,
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              cursor: "default",
            }}
          >
            Archived
          </div>
        </div>
      </div>
      <Grid cols="1">
        <div className={styles.wrapper}>
          <div style={{ margin: 20 }}>
            <div style={{ marginBottom: 30 }}>
              <Search
                callback={(query) => {
                  setSearchQueryString(query);
                }}
              />
            </div>
            <Table
              loading={loading}
              data={payload && payload.data ? data : null}
              badge={{
                col: "status",
                condition: [
                  { value: "Active", color: "green" },
                  { value: "Inactive", color: "red" },
                ],
              }}
              hide={["link", "id", "class", "type", "bodytype", "VIN"]}
              actions={{
                custom: [
                  {
                    icon: "archive",
                    tooltip: "Active this vehicle",
                    color: "#d32425",
                    action: (row) => activeVehicle(row.id),
                  },
                ],
              }}
            />
            {payload && (
              <Pagination
                pagesCount={payload.pages_count}
                active={payload.page}
                onChange={async (newPage) => {
                  setPage(newPage);
                  runAPI(newPage, searchQueryString);
                }}
              />
            )}
          </div>
        </div>
      </Grid>
    </Animate>
  );
}
